<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import CategoryGroupService from '@/services/category-group';

export default {
  page: {
    title: "Grupos de Categorias",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout },
  data() {
    return {
      title: "Grupos de Categorias",
      groups: [],
      groupToRemove: {},
      fields: [
        { key: 'description', label: 'Descrição' },
        { key: 'categories_count', label: 'Qtde. Categorias', formatter: (_v, _i, item) => {
          return (item.categories || []).length;
        } },
        { key: 'products_count', label: 'Qtde. Produtos', formatter: (_v, _i, item) => {
          return (item.products || []).length;
        } },
        { key: 'show_categories', label: 'Lista de Categorias', formatter: v => v ? 'Sim' : 'Não' },
        { key: 'show_as_carousel', label: 'Carrossel Home', formatter: v => v ? 'Sim' : 'Não' },
        { key: 'sequence', label: 'Ordem' },
        { key: 'actions', label: 'Ações' },
      ],
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      let loader = this.$loading.show();

      CategoryGroupService.getAll().then(res => {
        this.groups = res.data.data || [];
        loader.hide();
      }).catch(() => {
        loader.hide();
        this.$toast.error('Erro ao carregar grupos');
      });
    },
    removeGroup() {
      this.$bvModal.hide('modal-remove');

      CategoryGroupService.remove(this.groupToRemove._id).then(() => {
        this.load();
        this.$toast.open('Grupo removido');
      }).catch(() => {
        this.$toast.error('Erro ao remover grupo');
      });
    }
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">{{title}}</h4>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-12">
                <div class="text-right">
                  <router-link to="/category-groups/edit">
                    <button type="button" class="btn btn-primary btn-rounded mb-2 mr-2">
                      <i class="mdi mdi-plus mr-1"></i> Novo Grupo
                    </button>
                  </router-link>
                </div>
              </div>
            </div>

            <div class="table-responsive mb-0">
              <b-table
                show-empty
                emptyText="Nenhum registro para exibir"
                :items="groups"
                :fields="fields"
                responsive="sm"
                head-variant="light"
              >
                <template v-slot:cell(actions)="row">
                  <b-dropdown class="card-drop" variant="white" right toggle-class="p-0">
                    <template v-slot:button-content>
                      <i class="mdi mdi-dots-horizontal font-size-18"></i>
                    </template>

                    <router-link class="dropdown-item" :to="'/category-groups/edit/' + row.item._id">
                      <i class="fas fa-pencil-alt text-success mr-2 mt-2"></i> Editar
                    </router-link>

                    <b-dropdown-item v-b-modal.modal-remove @click="groupToRemove = row.item">
                      <i class="fas fa-trash-alt text-danger mr-2 mt-2"></i> Excluir
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-remove"
      title="Excluir Grupo?"
      title-class="font-18"
      centered
    >
      <p>Confirma a exclusão do grupo "{{groupToRemove.description}}"?</p>

      <div slot="modal-footer">
        <b-btn variant="link" @click="$bvModal.hide('modal-remove')" class="mr-3">Cancelar</b-btn>
        <b-btn variant="primary" @click="removeGroup">Excluir</b-btn>
      </div>
    </b-modal>
  </Layout>
</template>
